__turbopack_context__.v({
  "grid": "styles-module-scss-module__NgdOlG__grid",
  "heading": "styles-module-scss-module__NgdOlG__heading",
  "section": "styles-module-scss-module__NgdOlG__section",
});
